module.exports = __webpack_public_path__ + "static/media/dashboard.d6a3ca5d.png";